import type { EmvConfigurationDto } from "../../types/EmvConfigurationDto";
import type { EmvConfigurationEntity } from "../../types/EmvConfigurationEntity";

export const EmvConfigurationDtoToEntity = ({ ...rest }: Readonly<EmvConfigurationDto>): EmvConfigurationEntity => {
    return { ...rest };
};
